import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useCurrentUser } from '../hooks/useApi';

interface AdminRouteProps {
  children?: React.ReactNode;
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { data: user } = useCurrentUser();
  
  if (!user?.permissions?.includes('market_compass.admin')) {
    return <Navigate to="/" replace />;
  }
  
  return <>{children || <Outlet />}</>;
};